<template>
    <div class="fill-height">
        <v-container class="pa-0" fluid>
                <v-row>
                    <v-col class="page-content" cols="12">
                        <div :class="{'mr-12':isManager}">
                            <v-text-field
                                    v-model="search"
                                    class="datatable-search"
                                    dense
                                    hide-details
                                    outlined
                                    prepend-inner-icon="mdi-magnify"/>
                            <v-data-table
                                    :headers="header"
                                    :items="filteredUsers"
                                    :loading="loading"
                                    :search="search"
                                    class="rounded-lg shadow my-6"
                                    sort-by="Role">
                                <template v-slot:[`item.AvatarUrl`]="{item}">
                                    <v-avatar size="35">
                                        <img
                                                v-if="item.AvatarUrl"
                                                :src="item.AvatarUrl"
                                                alt="avatar">
                                        <v-icon v-else size="50">
                                            mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                                </template>
                                <template v-slot:[`header.Role`]>
                                    <FilterDropDown
                                            v-model="filters.role"
                                            :available-values="Array.from(availableValues.role)"
                                            :filter-values="userRoles"
                                            :name="$t('circles.role')"/>
                                </template>
                                <template v-slot:[`header.ReceiveNotifications`]>
                                    <FilterDropDown
                                            v-model="filters.receiveNotifications"
                                            :available-values="Array.from(availableValues.receiveNotifications)"
                                            :filter-values="receiveNotifications"
                                            :name="$t('circles.receiveNotifications')"/>
                                </template>
                                <template v-slot:[`item.Role`]="{item}">
                                    {{ getUserRole(item.Role) }}
                                </template>

                                <template v-slot:[`item.ReceiveNotifications`]="{item}">
                                    {{ item.ReceiveNotifications ? $t('yes') : $t('no') }}
                                </template>

                                <template v-if="isManager" v-slot:[`item.actions`]="{item}">
                                    <span class="data-table-actions-column">
                                    <TableAction :tooltip="$t('tooltips.settings')" icon="mdi-cog"
                                                 @click="openUserSettings(item)"/>
                                    <TableAction v-if="isAdmin && item.UserID !== userID"
                                                 :tooltip="$t('tooltips.sendNotification')"
                                                 icon="mdi-bell-badge"
                                                 @click="sendNotificationToUser(item)"/>
                                    <TableAction v-if="item.Role === CIRCLE_USER_ROLE_USER && !circle.Default"
                                                 :tooltip="$t('tooltips.removeFromCircle')"
                                                 icon="mdi-delete"
                                                 @click="deleteUser(item.UserID)"/>
                                    </span>
                                </template>
                            </v-data-table>
                        </div>
                        <div v-if="isAdmin || (isManager && !circle.Default)" class="action-buttons">
                            <v-btn
                                    class="mb-4 accentText--text"
                                    color="accent"
                                    dark
                                    fab
                                    small
                                    @click="actionOpen = !actionOpen"
                            >
                                <v-icon v-if="actionOpen">
                                    mdi-chevron-down
                                </v-icon>
                                <v-icon v-else>
                                    mdi-chevron-up
                                </v-icon>
                            </v-btn>
                            <v-slide-y-transition>
                                <div v-show="actionOpen">
                                    <div v-if="!circle.Default" class="mb-2 mt-2">
                                        <v-tooltip color="primary" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <router-link
                                                        :to="{name: 'circleMemberAdd', params: {id: $route.params.id}}">
                                                    <v-btn
                                                            color="primary"
                                                            dark
                                                            fab
                                                            small
                                                            v-bind="attrs"
                                                            v-on="on">
                                                        <v-icon color="secondary">mdi-plus</v-icon>
                                                    </v-btn>
                                                </router-link>
                                            </template>
                                            <span class="secondary--text">{{ $t('tooltips.addNewMember') }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-if="isAdmin" class="mb-2">
                                        <v-tooltip color="primary" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                        color="primary"
                                                        dark
                                                        fab
                                                        small
                                                        v-bind="attrs"
                                                        @click="openInviteDialog = true"
                                                        v-on="on"
                                                >
                                                    <v-icon color="secondary">mdi-account-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span class="secondary--text">{{ $t('circles.inviteUserToApp') }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-if="isAdmin" class="mb-2">
                                        <v-tooltip color="primary" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                        color="primary"
                                                        dark
                                                        fab
                                                        small
                                                        v-bind="attrs"
                                                        @click="sendNotificationToCircle"
                                                        v-on="on">
                                                    <v-icon color="secondary">mdi-bell-badge</v-icon>
                                                </v-btn>
                                            </template>
                                            <span class="secondary--text">{{ $t('tooltips.sendNotification') }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-if="isAdmin && !circle.Default" class="mb-2">
                                        <v-tooltip color="primary" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                        color="primary"
                                                        dark
                                                        fab
                                                        small
                                                        v-bind="attrs"
                                                        @click="deleteCircle"
                                                        v-on="on">
                                                    <v-icon color="secondary">mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span class="secondary--text">{{ $t('tooltips.deleteCircle') }}</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </v-slide-y-transition>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <DeleteDialog ref="deleteDialog" :loading="deleteLoading"/>
            <InviteDialog :open="openInviteDialog" @close="openInviteDialog=false"/>
            <PeopleDetailsDialog :open="openPeopleDialog" :user="user" @close="openPeopleDialog = false"
                                 @updateTable="getCircle"/>
    </div>
</template>

<script>
import {CIRCLE_USER_ROLE_MANAGER, CIRCLE_USER_ROLE_USER} from "@/helper/constants";
import DeleteDialog from "@/components/reusable/Dialog/DeleteDialog";
import InviteDialog from "@/components/reusable/Dialog/InviteDialog";
import PeopleDetailsDialog from "@/components/reusable/Dialog/PeopleDetailsDialog";
import FilterDropDown from "@/components/reusable/FilterDropDown/FilterDropDown";

export default {
  name: "CircleEdit",
  components: {PeopleDetailsDialog, InviteDialog, DeleteDialog, FilterDropDown},
  mounted() {
    this.getCircle();
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
  data() {
    return {
      actionOpen: true,
      circle: null,
      circleUsers: [],
      loading: false,
      deleteLoading: false,
      search: '',
      fab: true,
      openAddEditDialog: false,
      openInviteDialog: false,
      CIRCLE_USER_ROLE_USER,
      openPeopleDialog: false,
      user: {},
      filters: {
        receiveNotifications: [],
        role: [],
      },
      availableValues: {
        receiveNotifications: new Set(),
        role: new Set(),
      },
    };
  },
  computed: {
    filteredUsers() {
      return this.circleUsers.filter(user => this.filters.receiveNotifications.includes(user.ReceiveNotifications) && this.filters.role.includes(user.Role));
    },
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    userID() {
      return this.$store.getters.getUserId;
    },
    isManager() {
      return this.circleUsers.filter(user => user.UserID === this.userID && user.Role === CIRCLE_USER_ROLE_MANAGER).length > 0;
    },
    header() {
      return [
        {text: this.$t('circles.avatar'), value: 'AvatarUrl'},
        {text: this.$t('authentication.firstName'), value: 'FirstName'},
        {text: this.$t('authentication.lastName'), value: 'LastName'},
        {text: this.$t('authentication.email'), value: 'Email'},
        {text: this.$t('circles.role'), value: 'Role'},
        {text: this.$t('circles.receiveNotifications'), value: 'ReceiveNotifications'},
        {text: '', value: 'actions', class: 'data-table-actions-column', cellClass: 'data-table-actions-column', sortable: false, width: 200, align: 'center'}
      ];
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    userRoles() {
      return [
        {text: this.$t('circles.user'), value: CIRCLE_USER_ROLE_USER},
        {text: this.$t('circles.manager'), value: CIRCLE_USER_ROLE_MANAGER},
      ];
    },
    receiveNotifications() {
      return [
        {text: this.$t('yes'), value: true},
        {text: this.$t('no'), value: false},
      ];
    },
  },
  methods: {
    getUserRole(value) {
      const role = this.userRoles.filter((role) => role.value === value);
      return role.length ? role[0].text : value;
    },
    getCircle() {
      let url = this.$store.getters.circles(this.organizationId, this.$route.params.id);
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.circle = data.Result;
      });
      url = this.$store.getters.circleUsers(this.organizationId, this.$route.params.id);
      this.axios.get(url).then(({data}) => {
        this.circleUsers = data.Result;
        this.circleUsers.forEach(item => {
          this.availableValues.receiveNotifications.add(item.ReceiveNotifications);
          this.availableValues.role.add(item.Role);
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    deleteCircle() {
      this.$refs.deleteDialog.openDialog().then(result => {
        if (result) {
          const url = this.$store.getters.circle(this.circle.CircleID);
          if (this.deleteLoading) {
            return;
          }
          this.deleteLoading = true;
          this.axios.delete(url).then(() => {
            this.$router.push({name: 'myCircles'});
          }).finally(() => {
            this.deleteLoading = false;
          });
        }
      });
    },
    deleteUser(userID) {
      this.$refs.deleteDialog.openDialog().then(result => {
        if (result) {
          const url = this.$store.getters.circleUser(this.circle.CircleID, userID);
          this.axios.delete(url).then(() => {
            this.getCircle();
          });
        }
      });
    },
    openUserSettings(user) {
      this.user = {...user};
      this.openPeopleDialog = true;
    },
    sendNotificationToUser(user) {
      this.$router.push({name: 'sendNotifications', params: {userID: user.UserID}});
    },
    sendNotificationToCircle() {
      this.$router.push({name: 'sendNotifications', params: {circleID: this.$route.params.id}});
    },
    handleKeyup(e) {
      if (e.key === 'Escape') {
        this.$router.back();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "circle-edit";
</style>